import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setFilteredArchive,
  setSortOrder,
} from "../../../../../redux/filter/filteredArchiveSlice";
import styles from "./styles.module.scss";
import { compareDates } from "../../../../../services/CompareDates";

const Sorter = () => {
  const transcripts = useSelector(
    (state) => state.filteredArchiveSlice.transcripts
  );
  const currentSortOrder = useSelector(
    (state) => state.filteredArchiveSlice.sortOrder
  );

  const dispatch = useDispatch();
  useEffect(() => {
    let sortedTranscripts;

    switch (currentSortOrder) {
      case "Title descending":
        sortedTranscripts = [...transcripts].sort((a, b) =>
          b.title.localeCompare(a.title)
        );
        break;
      case "Title ascending":
        sortedTranscripts = [...transcripts].sort((a, b) =>
          a.title.localeCompare(b.title)
        );
        break;
      case "Upload date descending":
        sortedTranscripts = [...transcripts].sort((a, b) =>
          compareDates(a, b, "descending")
        );
        break;
      case "Upload date ascending":
        sortedTranscripts = [...transcripts].sort((a, b) =>
          compareDates(a, b, "ascending")
        );
        break;
      default:
        sortedTranscripts = transcripts;
    }
    dispatch(setFilteredArchive(sortedTranscripts));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSortOrder]);
  return (
    <fieldset className={styles.fieldset}>
      <legend htmlFor="sortBy">Sort by</legend>
      <select
        name="sortBy"
        value={currentSortOrder}
        onChange={(e) => dispatch(setSortOrder(e.target.value))}
      >
        <option>Title descending</option>
        <option>Title ascending</option>
        <option>Upload date descending</option>
        <option>Upload date ascending</option>
      </select>
    </fieldset>
  );
};
export default Sorter;
